import React from 'react';

/**
 * Triângulo de alerta dos avisos críticos do Portal (13/08/2026).
 *
 * SVG inline, e não arquivo em `src/img/`, por dois motivos: usa `currentColor` (herda a cor
 * do aviso, então serve a qualquer variante sem duplicar arquivo) e é pequeno o bastante para
 * não justificar um asset e um import por tela.
 *
 * `aria-hidden`: o ícone não acrescenta informação a quem usa leitor de tela — o texto do
 * aviso já diz tudo, e anunciá-lo viraria ruído.
 */
const IconeAlerta: React.FC<{ tamanho?: number }> = ({ tamanho = 18 }) => (
  <svg
    width={tamanho}
    height={tamanho}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

export default IconeAlerta;
